import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-saml',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class SSOSaml extends Vue {

    @Prop()
    public isEditAllow: any;

    @Prop()
    public ssoFields: any;

    public isNotObjectResponse: boolean = false;

    public isNotObjectDistrict: boolean = false;

    public isNotObjectAdditionalParams: boolean = false;

    public onBack() {
        this.$emit('onBack');
    }

    public onEdit() {
        this.$emit('onEdit');
    }

    public onSubmit() {
        this.$emit('onSubmit', this.ssoFields);
    }

    private created() {
        if (this.ssoFields) {
            this.isNotObjectResponse = typeof this.ssoFields.response_mapper === 'object';
            this.isNotObjectDistrict = typeof this.ssoFields.district_mapper === 'object';
            this.isNotObjectAdditionalParams = typeof this.ssoFields.additional_params === 'object';
        }
    }

}
